module.exports = __webpack_public_path__ + "static/media/Back to Bach.7e663b50.jpg";